import React from 'react';
import { Box, Grid, Skeleton } from '@mantine/core';
import { PackageSkeleton } from './PackageSkeleton';

interface CategorySkeletonProps {
  packagesCount?: number;
}

export const CategorySkeleton: React.FC<CategorySkeletonProps> = ({ packagesCount = 6 }) => {
  return (
    <Box>
      <Skeleton height={32} width='30%' mb={16} />
      <Skeleton height={20} width='60%' mb={24} />

      <Grid gutter={16}>
        {Array.from({ length: packagesCount }).map((_, index) => (
          <Grid.Col key={index} span={{ base: 12, sm: 6, md: 4 }}>
            <PackageSkeleton />
          </Grid.Col>
        ))}
      </Grid>
    </Box>
  );
};
